import { useEffect, useState, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { fetchFinancialJobs } from "../service";
import DivSpinner from "../../components/divSpinner";
import TableRow from "./TableRow";

const TABLE_HEADERS = [
    "Ref",
    "Tradesperson",
    "Customer",
    "Postcode",
    "Service Categories",
    "Created",
    "Working hours",
    "Total labour charges",
    "Labour commission",
    "Materials charges",
    "Materials commission",
    "Discount",
    "Total"
];

const Table = ({ selectedFtm, dataFilter, page, setTotalPages, setTotalJobs, ftm_payment_filter = undefined, refreshKey = null }) => {
    const navigate = useNavigate();

    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(true);

    /**
     * Fetch Jobs
     */
    const loadJobs = useCallback(async () => {
        try {
            setLoading(true);

            const response = await fetchFinancialJobs(page, selectedFtm?.value, dataFilter, ftm_payment_filter);

            setJobs(response?.data ?? []);
            setTotalPages(response?.totalPages ?? 0);
            setTotalJobs(response?.total ?? 0);
        } catch (error) {
            console.error("Error fetching financial jobs:", error);
        } finally {
            setLoading(false);
        }
    }, [dataFilter, page, selectedFtm?.value, setTotalJobs, setTotalPages, ftm_payment_filter]);

    useEffect(() => {
        loadJobs();
    }, [loadJobs, refreshKey]);

    /**
     * Navigate
     */
    const handleRowClick = useCallback(
        (ftmId) => {
            navigate(`/ftm/valuation/${ftmId}`);
        },
        [navigate]
    );

    /**
     * Table Height
     */
    const tableHeight = useMemo(() => {
        return { height: `${window.innerHeight - 387}px` };
    }, []);

    if (loading) {
        return (
            <div style={tableHeight}>
                <DivSpinner />
            </div>
        );
    }

    return (
        <div
            className="table-responsive p-0 m-3"
            style={{ height: "500px", overflowY: "auto" }}
        >
            <table className="table align-items-center mb-0">

                <thead>
                    <tr>
                        {TABLE_HEADERS.map((header) => (
                            <th
                                key={header}
                                className="text-uppercase text-center text-secondary text-sm font-weight-bolder opacity-7"
                            >
                                {header}
                            </th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {jobs.length === 0 ? (
                        <tr>
                            <td
                                colSpan={TABLE_HEADERS.length}
                                className="text-center py-4"
                            >
                                Sorry, no data found!
                            </td>
                        </tr>
                    ) : (
                        jobs.map((job) => (
                            <TableRow
                                key={job.job_id}
                                job={job}
                                onRowClick={handleRowClick}
                            />
                        ))
                    )}
                </tbody>

            </table>
        </div>
    );
};

export default Table;